import React from 'react';
import { Sparkles } from 'lucide-react';

export function NotificationSettings({ briefingMode, onChange, saving }) {
  return (
    <div className="bg-surface rounded-lg border border-border p-6 mb-4">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-medium text-foreground">AI Assistant</h2>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Daily Briefing Mode
          </label>
          <p className="text-sm text-text-muted mb-3">
            Choose how your daily briefing is generated
          </p>
          <div className="space-y-2">
            <label className="flex items-center gap-3 p-3 rounded-lg border border-border cursor-pointer hover:bg-surface-hover transition-colors">
              <input
                type="radio"
                name="briefing_mode"
                value="auto"
                checked={briefingMode === 'auto'}
                onChange={() => onChange('auto')}
                disabled={saving}
                className="w-4 h-4 text-primary"
              />
              <div>
                <div className="text-sm font-medium text-foreground">Auto</div>
                <div className="text-xs text-text-muted">
                  Regenerate every 2 hours automatically
                </div>
              </div>
            </label>
            <label className="flex items-center gap-3 p-3 rounded-lg border border-border cursor-pointer hover:bg-surface-hover transition-colors">
              <input
                type="radio"
                name="briefing_mode"
                value="manual"
                checked={briefingMode === 'manual'}
                onChange={() => onChange('manual')}
                disabled={saving}
                className="w-4 h-4 text-primary"
              />
              <div>
                <div className="text-sm font-medium text-foreground">Manual</div>
                <div className="text-xs text-text-muted">
                  Only refresh when you click the button
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
